exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".starRate-stars{color:#e8d04c!important}", "", {"version":3,"sources":["C:/ias/Projects/Athos/CondoPlaza/condoplaza-frontend/Condoplaza.Vue/src/components/StarRate.vue"],"names":[],"mappings":"AACA,gBACE,uBAAyB,CAC1B","file":"StarRate.vue","sourcesContent":["\n.starRate-stars{\n  color: #e8d04c!important;\n}\n"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":true,"sourceMap":true}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-1f0c6b16","scoped":false,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/StarRate.vue
// module id = 608
// module chunks = 3